import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import GoogleMapReact from "google-map-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import TeamCard from "../components/TeamCard";
import TeamMapPin from "../components/TeamMapPin";
import { Team } from "../interfaces";
import { getAppSurfaceStyles } from "../theme/siteTheme";
import { TeamsProvider, useTeams } from "./TeamsContext";

const MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";

const TeamListPage: React.FC = () => {
  const navigate = useNavigate();
  const { teams } = useTeams(); // teams: Team[]
  const theme = useTheme();
  const styles = getAppSurfaceStyles(theme);

  return (
    <Box id="teams" sx={{ pb: 9, maxWidth: 1200, mx: "auto", mt: 4 }}>
      <Typography variant="h2" sx={{ mb: 3, textAlign: "center" }}>
        Mannschaften
      </Typography>
      <Box sx={{ ...styles.mapFrame, height: 400, mb: 4 }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: MAP_API_KEY }}
          defaultCenter={{ lat: 48.538, lng: 9.041 }}
          defaultZoom={9}
        >
          {teams.map((team: Team) => {
            const coords =
              team.spielort && team.spielort.lat && team.spielort.lng
                ? { lat: team.spielort.lat, lng: team.spielort.lng }
                : { lat: 48.5, lng: 9.0 };
            return (
              <TeamMapPin
                key={team.id}
                team={team}
                lat={coords.lat}
                lng={coords.lng}
              />
            );
          })}
        </GoogleMapReact>
      </Box>
      <Grid container spacing={3} alignItems="stretch">
        {teams.map((team: Team) => (
          <Grid
            key={team.id}
            size={{ xs: 12, sm: 6, lg: 4 }}
            sx={{ display: "flex" }}
          >
            <Box
              sx={{ width: "100%", cursor: "pointer" }}
              onClick={() =>
                navigate(`/teams/${encodeURIComponent(team.name)}`, {
                  state: { id: team.id },
                })
              }
            >
              <TeamCard team={team} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

// Wrap export with TeamsProvider
const TeamListPageWithProvider: React.FC = () => (
  <TeamsProvider>
    <TeamListPage />
  </TeamsProvider>
);

export default TeamListPageWithProvider;
